import { createRouter, createWebHistory } from "vue-router";
import authRoutes from "./auth.js";
import toolRoutes from "./tools.js";
import userRoutes from "./users.js";
import subscriptionRoutes from "./subscriptions.js";
import NotFoundView from "@/views/not-found/NotFoundView.vue";
import store from "@/store/index";
import productsRoutes from "./products.js";
import membersRoutes from "./members.js";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home/HomeView.vue"),
  },
  ...authRoutes,
  ...toolRoutes,
  ...userRoutes,
  ...subscriptionRoutes,
  ...productsRoutes,
  ...membersRoutes,
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFoundView,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const user = store.getters.user;
  if (user && (to.name === "login" || to.name === "register")) {
    next({ name: "home" });
  } else if (user && (to.name !== "login" || to.name !== "register")) {
    next();
  } else {
    if (
      !user &&
      (to.name === "login" ||
        to.name === "register" ||
        to.name === "verify-email" ||
        to.name === "reset-password")
    ) {
      next();
    } else {
      next({ name: "login" });
    }
  }
});
